"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createTheme = exports.applyThemeSettings = exports.THEME_WRAPPER_CLASS = void 0;
var _tinycolor = require("@ctrl/tinycolor");
var _mergeProps = _interopRequireDefault(require("./mergeProps"));
var _Theme = require("../themes/Theme");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
/***
 * Checks theme colors to ensure validity.
 * @throws {Error}
 */
var validateThemeColors = function validateThemeColors(theme) {
  var invalidColors = Object.keys(theme.colors).map(function (key) {
    return theme.colors[key];
  }).filter(function (prop) {
    return !new _tinycolor.TinyColor(prop).isValid;
  }).filter(function (nonColorProp) {
    return !nonColorProp.startsWith("linear-gradient");
  });
  if (invalidColors.length) {
    throw new Error("The following custom template color(s) were invalid: ".concat(invalidColors));
  }
};

/** The class that wraps around all children in the ThemeProvider. */
var THEME_WRAPPER_CLASS = exports.THEME_WRAPPER_CLASS = "icf-react-components";

/** Apply theme settings - primary color and content direction */
var applyThemeSettings = exports.applyThemeSettings = function applyThemeSettings(theme, primary, direction, language) {
  // Need to create a dereferenced clone of the object
  // {...theme} copies nested values by reference because of #JustJsThings
  // See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign#Deep_Clone
  return _objectSpread(_objectSpread(_objectSpread({
    version: "8.47.1"
  }, theme), {}, {
    colors: _objectSpread(_objectSpread({}, theme.colors), {}, {
      primary: primary.primaryBase,
      primaryLight: primary.primaryLight,
      primaryDark: primary.primaryDark
    })
  }, {
    direction: direction
  }), {
    language: language
  });
};
var getHexForPrimary = function getHexForPrimary(color) {
  if (!color) {
    return null;
  }
  return new _tinycolor.TinyColor(color).toHexString();
};
var shadePrimaryLight = function shadePrimaryLight(color) {
  if (!color) {
    return null;
  }
  return new _tinycolor.TinyColor(color).lighten().toHexString();
};
var shadePrimaryDark = function shadePrimaryDark(color) {
  if (!color) {
    return null;
  }
  return new _tinycolor.TinyColor(color).darken().toHexString();
};
var getPrimaryScale = function getPrimaryScale(activeTheme, customTheme, primaryColor) {
  var _ref, _customTheme$colors$p, _customTheme$colors, _ref2, _ref3, _customTheme$colors$p2, _customTheme$colors2, _ref4, _ref5, _customTheme$colors$p3, _customTheme$colors3;
  var primaryBase = (_ref = (_customTheme$colors$p = customTheme === null || customTheme === void 0 || (_customTheme$colors = customTheme.colors) === null || _customTheme$colors === void 0 ? void 0 : _customTheme$colors.primary) !== null && _customTheme$colors$p !== void 0 ? _customTheme$colors$p : getHexForPrimary(primaryColor)) !== null && _ref !== void 0 ? _ref : activeTheme.colors.primary;
  var primaryLight = (_ref2 = (_ref3 = (_customTheme$colors$p2 = customTheme === null || customTheme === void 0 || (_customTheme$colors2 = customTheme.colors) === null || _customTheme$colors2 === void 0 ? void 0 : _customTheme$colors2.primaryLight) !== null && _customTheme$colors$p2 !== void 0 ? _customTheme$colors$p2 : shadePrimaryLight(primaryColor)) !== null && _ref3 !== void 0 ? _ref3 : activeTheme.colors.primaryLight) !== null && _ref2 !== void 0 ? _ref2 : shadePrimaryLight(activeTheme.colors.primary);
  var primaryDark = (_ref4 = (_ref5 = (_customTheme$colors$p3 = customTheme === null || customTheme === void 0 || (_customTheme$colors3 = customTheme.colors) === null || _customTheme$colors3 === void 0 ? void 0 : _customTheme$colors3.primaryDark) !== null && _customTheme$colors$p3 !== void 0 ? _customTheme$colors$p3 : shadePrimaryDark(primaryColor)) !== null && _ref5 !== void 0 ? _ref5 : activeTheme.colors.primaryDark) !== null && _ref4 !== void 0 ? _ref4 : shadePrimaryDark(activeTheme.colors.primary);
  return {
    primaryLight: primaryLight,
    primaryBase: primaryBase,
    primaryDark: primaryDark
  };
};

/**
 * Creates an `ITheme`.
 *
 * `customTheme.mode` is used over `props.themeMode`.
 * `customTheme.colors.primary` is used over `props.primaryColor`.
 *
 * @param themes - An object of `ThemeMode` to `IThemeDefiniton` pairs
 * @param themeMode - The active `ThemeMode`
 * @param primaryColor - An optional primary color override that will be merged into the currently active theme
 * @param customTheme - An optional set of theming overrides that will be merged into the currently active theme
 * @param direction - An optional set for direction to accomodate right-to-left languages
 * @returns
 */
var createTheme = exports.createTheme = function createTheme(themes, themeMode, primaryColor, customTheme, direction, language) {
  var _ref6, _ref7, _customTheme$type;
  var activeThemeMode = (_ref6 = (_ref7 = (_customTheme$type = customTheme === null || customTheme === void 0 ? void 0 : customTheme.type) !== null && _customTheme$type !== void 0 ? _customTheme$type : customTheme === null || customTheme === void 0 ? void 0 : customTheme.mode) !== null && _ref7 !== void 0 ? _ref7 : themeMode) !== null && _ref6 !== void 0 ? _ref6 : _Theme.ThemeMode.dark;
  var activeTheme = themes[activeThemeMode];
  var activePrimaryColor = getPrimaryScale(activeTheme, customTheme, primaryColor);
  var resultTheme = applyThemeSettings(customTheme ? (0, _mergeProps.default)(activeTheme, customTheme) : activeTheme, activePrimaryColor, direction, language);
  validateThemeColors(resultTheme);
  return resultTheme;
};